<div class="Modal ModalTelefoneErrado">
  <div class="HeaderModal">
    <div class="IconModal float-start">
      <span class="material-icons"> {{ data.icon }} </span>
      <p>{{ data.textIcon }}</p>
    </div>
    <span class="material-icons float-end CloseModal" (click)="onNoClick()">
      close
    </span>
  </div>

  <div class="ModalContent">
    <h1 class="TtlModal text-start">
      {{data.title}}
    </h1>
    <p class="TxtModal text-start">{{data.text}}</p>
  </div>

  <div class="ModalFooter" *ngIf='data.textExtra!=""'>
    <p class="TxtModal text-start">{{data.textExtra}}</p>
  </div>

  <hr *ngIf='data.textExtra==""'>

  <div class="ModalContent">  
    <div class="row align-items-center">
      <div class="col-md-6">
        <div class="d-none d-md-block d-lg-block d-xl-block d-xxl-block">
          <app-btn-sac></app-btn-sac>
        </div>

        <div class="d-md-none d-lg-none d-xl-none d-xxl-none d-flex justify-content-center align-items-cente">
          <app-btn-sac></app-btn-sac>
        </div>
      </div>

      <div class="col-md-6 d-flex justify-content-center align-items-cente">
        <app-btn-whatsapp></app-btn-whatsapp>
      </div>
    </div>
  </div>

  <div class="row"  *ngIf='data.linkAdress!="" && data.textLink!=""'>
    <div class="col text-center ModalFooter">
      <a [routerLink]="data.linkAdress" mat-dialog-close class="mt-24">{{data.textLink}}</a>
    </div>
  </div>
</div>
